import { Scene as L, Actor as f, Canvas as w, Util as g, Color as u, Class as O, GameEvent as x, ScreenElement as m } from "excalibur";
class S extends L {
  constructor() {
    super(...arguments), this.labels = [], this.elapsedTime = 0, this.complete = !1;
  }
  onInitialize(t) {
    const e = {
      sm: Math.max(t.drawHeight, t.drawWidth) / 28,
      lg: Math.max(t.drawHeight, t.drawWidth) / 10
    };
    this.progressBar = new v({
      x: t.drawWidth / 2,
      y: t.drawHeight / 2,
      width: t.drawWidth * 0.75,
      height: Math.round(e.sm)
    }), t.add(this.progressBar);
  }
  onActivate() {
    this.complete = !1;
  }
  onLoad(t) {
    this.progressBar.progress = t;
  }
  onLoadComplete() {
    this.complete = !0, this.progressBar.actions.clearActions();
  }
  onPreUpdate(t, e) {
    this.elapsedTime += e;
  }
}
class v extends f {
  constructor(t) {
    super(t), this.progress = 0;
  }
  onInitialize(t) {
    const e = new w({
      width: this.width,
      height: this.height,
      quality: window.devicePixelRatio,
      draw: (s) => {
        g.DrawUtil.roundRect(s, 0, 0, this.width, this.height, this.height / 2, u.White), g.DrawUtil.roundRect(s, 0, 0, this.width * Math.max(0.05, Math.min(1, this.progress / 100)), this.height, this.height / 2, u.White, u.White);
      }
    });
    this.graphics.use(e);
  }
}
class I extends O {
  constructor(t) {
    super(), this.data = [], this.canvas = { draw() {
    } }, this.addResources(t != null ? t : []);
  }
  async load() {
    let t = 0;
    const e = this.data.filter((i) => !i.isLoaded());
    this.emit("start", e), this.emit("progress", new l(this, 0));
    const s = await Promise.all(e.map((i) => i.load().finally(() => {
      t++, this.emit("progress", new l(this, t / e.length * 100));
    })));
    return this.emit("progress", new l(this, 100)), this.emit("complete", e), s;
  }
  addResources(t) {
    this.data.push(...t.filter((e) => !e.isLoaded()));
  }
  isLoaded() {
    return this.data.every((t) => t.isLoaded());
  }
  wireEngine() {
  }
  update() {
  }
  draw() {
  }
}
class l extends x {
  constructor(t, e) {
    super(), this.target = t, this.progress = e;
  }
}
class B {
  constructor(t) {
    this.isTransitioning = !1, this.isBooting = !0, this.resourceLoader = new I(), this.routes = t.routes, this.loaders = {
      default: S,
      ...t.loaders
    };
  }
  start(t) {
    return this.engine = t, this.isBooting = !0, Object.entries(this.routes).forEach(([e, s]) => {
      p(s) && this.engine.add(e, new s());
    }), Object.entries(this.loaders).forEach(([e, s]) => {
      this.engine.add(e, new s());
    }), t.start(null);
  }
  async goto(t, e = {}) {
    const s = e.transition;
    let i = this.engine.scenes[t];
    if (!this.routes[t])
      throw new Error(`No scene named ${t}`);
    return this.sceneNeedsLoading(t) ? i = await this.loadScene(t, e) : await this.executeTransition({
      type: "outro",
      transition: s
    }), i.once("activate", () => {
      var r;
      (r = e.onActivate) == null || r.call(e, i);
    }), this.engine.goToScene(t, e.data), await this.executeTransition({
      type: "intro",
      transition: s
    }), this.isBooting = !1, i;
  }
  async preloadScene(t) {
    var s, i;
    let e = this.engine.scenes[t];
    if (this.sceneNeedsLoading(t)) {
      if (!e) {
        const a = this.routes[t], d = p(a) ? a : await a().then((n) => n.default ? n.default : n);
        if (d)
          e = new d(), e.name = t, this.engine.add(t, e);
        else
          throw new Error(`"${t}" did not return a Scene`);
      }
      const r = this.engine.currentScene, c = new Promise((a) => {
        r.defer ? r.once("continue", a) : a(void 0);
      });
      (s = r.onLoadStart) == null || s.call(r);
      const h = ({ progress: a }) => {
        var d, n;
        (n = (d = this.engine.currentScene).onLoad) == null || n.call(d, a);
      };
      this.resourceLoader.on("progress", h), await this.resourceLoader.load(), (i = r.onLoadComplete) == null || i.call(r), this.resourceLoader.off("progress", h), await c;
    }
    return e;
  }
  async loadScene(t, e = {}) {
    var r;
    const s = e.transition, i = (r = e.loader) != null ? r : "default";
    if (this.sceneNeedsLoading(t)) {
      this.isBooting || await this.executeTransition({
        type: "outro",
        transition: s
      }), this.engine.goToScene(i);
      let c, h = Boolean(s && this.isBooting);
      !this.isBooting && s && (s.persistOnLoading !== !1 && this.engine.add(s), typeof s.persistOnLoading == "number" ? c = setTimeout(() => {
        this.executeTransition({
          type: "intro",
          transition: s
        }), h = !0;
      }, s.persistOnLoading) : s.persistOnLoading === !1 && (await this.executeTransition({
        type: "intro",
        transition: s
      }), h = !0)), await this.preloadScene(t), h && (this.isBooting && this.engine.add(s), await this.executeTransition({
        type: "outro",
        transition: s
      })), clearTimeout(c);
    }
    return this.engine.scenes[t];
  }
  addResource(t) {
    return this.resourceLoader.addResources(Array.isArray(t) ? t : [t]);
  }
  sceneNeedsLoading(t) {
    return this.engine.scenes[t] ? !this.resourceLoader.isLoaded() : !0;
  }
  async executeTransition({
    type: t,
    transition: e,
    progress: s = 0
  }) {
    var r, c, h, a;
    const i = this.engine.currentScene;
    return e && (this.isTransitioning = !0, i.isTransitioning = !0, i.engine.add(e), t === "outro" ? (r = i.onOutroStart) == null || r.call(i) : (c = i.onIntroStart) == null || c.call(i), e.on("outro", (d) => {
      var n;
      (n = i.onOutro) == null || n.call(i, d);
    }), e.on("intro", (d) => {
      var n;
      (n = i.onIntro) == null || n.call(i, d);
    }), await e.execute(t === "outro", s), t === "intro" ? ((h = i.onIntroComplete) == null || h.call(i), e.kill()) : (a = i.onOutroComplete) == null || a.call(i), i.isTransitioning = !1, this.isTransitioning = !1), e;
  }
}
function p(o) {
  return T(o);
}
function T(o) {
  if (typeof o != "function")
    return !1;
  const t = Object.getOwnPropertyDescriptor(o, "prototype");
  return t ? !t.writable : !1;
}
class y extends f {
  constructor({
    duration: t = 300,
    easing: e = (i) => i,
    ...s
  } = {}) {
    super(s), this.isOutro = !1, this.progress = 0, this.started = !1, this.duration = typeof t == "number" ? { outro: t, intro: t } : t, this.easing = e, this.persistOnLoading = s.persistOnLoading, this.on("preupdate", (i) => {
      this.started && (this.progress += Math.min(i.delta / this.getDuration(), 1), this.emit(this.isOutro ? "outro" : "intro", this.easing(this.progress)), this.progress >= 1 && (this.emit(this.isOutro ? "outrocomplete" : "introcomplete", void 0), this.started = !1, this.progress = 0));
    }), this.on("introstart", this.onIntroStart.bind(this)), this.on("intro", this.onIntro.bind(this)), this.on("introcomplete", this.onIntroComplete.bind(this)), this.on("outrostart", this.onOutroStart.bind(this)), this.on("outro", this.onOutro.bind(this)), this.on("outrocomplete", this.onOutroComplete.bind(this));
  }
  getDuration() {
    return this.isOutro ? this.duration.outro : this.duration.intro;
  }
  onIntroStart() {
  }
  onIntro(t) {
  }
  onIntroComplete() {
  }
  onOutroStart() {
  }
  onOutro(t) {
  }
  onOutroComplete() {
  }
  async execute(t, e = 0) {
    return this.isOutro = t, this.isInitialized || await new Promise((s) => {
      this.on("initialize", s);
    }), this.started = !0, this.progress = e, this.emit(t ? "outrostart" : "introstart", void 0), new Promise((s) => {
      this.on(t ? "outrocomplete" : "introcomplete", () => {
        s(null);
      });
    });
  }
}
class P extends y {
  constructor(t = {}) {
    super({
      duration: 300,
      z: 1 / 0,
      persistOnLoading: 200,
      ...t
    });
  }
  onInitialize(t) {
    this.el = new m({
      x: -1,
      y: -1,
      z: this.z,
      width: t.canvasWidth + 1 * 2,
      height: t.canvasHeight + 1 * 2,
      color: u.Black
    }), this.el.graphics.opacity = this.isOutro ? 0 : 1, this.addChild(this.el);
  }
  onIntroStart() {
    this.el.graphics.opacity = 1;
  }
  onOutroStart() {
    this.el.graphics.opacity = 0;
  }
  onIntro(t) {
    this.el.graphics.opacity = 1 - t;
  }
  onOutro(t) {
    this.el.graphics.opacity = t;
  }
}
class z extends y {
  constructor({ duration: t, ...e } = {}) {
    super({
      ...e,
      duration: {
        outro: 0,
        intro: t != null ? t : 150
      },
      z: 1 / 0
    });
  }
  onInitialize(t) {
    this.el = new m({
      x: 0,
      y: 0,
      z: this.z,
      width: t.canvasWidth,
      height: t.canvasHeight
    }), this.el.graphics.use(new w({
      quality: window.devicePixelRatio,
      width: t.canvasWidth,
      height: t.canvasHeight,
      draw: (e) => {
        this.screenshot && e.drawImage(this.screenshot, 0, 0, t.canvasWidth, t.canvasHeight, 0, 0, t.canvasWidth / window.devicePixelRatio, t.canvasHeight / window.devicePixelRatio);
      }
    })), this.addChild(this.el);
  }
  onIntroStart() {
    this.el.graphics.opacity = 1;
  }
  onOutroStart() {
    this.takeScreenshot();
  }
  onIntro(t) {
    this.el.graphics.opacity = 1 - t;
  }
  onOutro(t) {
  }
  onOutroComplete() {
  }
  takeScreenshot() {
    this.scene.engine.screenshot(!0).then((t) => {
      this.screenshot = t;
    });
  }
}
export {
  z as CrossFadeTransition,
  S as DefaultLoader,
  P as FadeTransition,
  B as Router,
  y as Transition
};
